import React from 'react';

const EmailCloudEyes = () => {
  return (
    <svg
      width="313"
      height="30"
      viewBox="0 0 313 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
        fill="black"
      />
      <path
        d="M10.5 14C12.9853 14 15 11.9853 15 9.5C15 7.01472 12.9853 5 10.5 5C8.01472 5 6 7.01472 6 9.5C6 11.9853 8.01472 14 10.5 14Z"
        fill="white"
      />
      <path
        d="M298 30C306.284 30 313 23.2843 313 15C313 6.71573 306.284 0 298 0C289.716 0 283 6.71573 283 15C283 23.2843 289.716 30 298 30Z"
        fill="black"
      />
      <path
        d="M293.5 14C295.985 14 298 11.9853 298 9.5C298 7.01472 295.985 5 293.5 5C291.015 5 289 7.01472 289 9.5C289 11.9853 291.015 14 293.5 14Z"
        fill="white"
      />
    </svg>
  );
};

export default EmailCloudEyes;
